import React, { useState, useEffect } from "react";

import ArticlesGridContainer from "../../Shared/ArticlesGridContainer";
import ArticlesHybridContainer from "../../Shared/ArticlesHybridContainer";
import ArticlesListContainer from "../../Shared/ArticlesListContainer";
import { IArticlesItem } from "../../interfaces";
import { mapArticlesList } from "../../../../utils";
import ArticlesHybridMirrorContainer from "modules/Content/Shared/ArticlesHybridMirrorContainer";
import { Col } from "antd";
interface IFavoriteArticles {
  articles: IArticlesItem[];
  isListView: boolean;
}

const FavoriteArticles: React.FC<IFavoriteArticles> = ({ articles, isListView }: IFavoriteArticles) => {
  //  const { articles:IArticlesItem  } = props;
  const articleSequence: Array<number> = [2, 3, 4, 4, 8];
  const [articleLists, setArticleLists] = useState<Array<Array<IArticlesItem>>>([]);

  const updateArticlesLists = () => {
    let tmpArticleLists = mapArticlesList(articles, articleSequence);
    setArticleLists(tmpArticleLists);
  };

  useEffect(() => {
    // add when mounted
    // if (articles.length > 0) {
    updateArticlesLists();
    // }
  }, [articles]);

  return (
    <div className="">
      {/* first row */}

      {isListView ? (
        <>
          <div className="">
            <ArticlesListContainer articles={articles} />
          </div>
        </>
      ) : (
        <>
          {articleLists && articleLists[0]?.length > 0 && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesGridContainer
                key="0"
                articles={articleLists[0]}
                imgHeight="230"
                imgWidth="613"
                articleSpan={12}
              />
            </div>
          )}

          {articleLists && articleLists[1]?.length > 0 && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesGridContainer
                key="1"
                smallBlog
                articles={articleLists[1]}
                imgHeight="170"
                imgWidth="401"
                articleSpan={8}
              />
            </div>
          )}

          {/* third row   */}
          {articleLists && articleLists[2]?.length > 0 && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesHybridContainer articles={articleLists[2]} />
            </div>
          )}

          {/* 4th row   */}
          {articleLists && articleLists[3]?.length > 0 && (
            <ArticlesHybridMirrorContainer articles={articleLists[3]} />
          )}

          <Col className="gutter-row" span={24}>
            {/* {typeof articleLists[4] !== "undefined" && ( */}
            {articleLists && articleLists[4]?.length > 0 && (
              <div className="padding-top-sm padding-bottom-sm list-style">
                <ArticlesListContainer articles={articleLists[4]} />
              </div>
            )}
          </Col>
        </>
      )}
    </div>
  );
};

export default FavoriteArticles;
